import axios from 'axios';

export const LAB_API = `${process.env.REACT_APP_BACKEND_URL}/api/lab`;

export const labApi = (token) => {
  const cfg = { headers: { Authorization: `Bearer ${token}` } };
  return {
    get: (path, params) => axios.get(`${LAB_API}${path}`, { ...cfg, params }).then((r) => r.data),
    post: (path, body) => axios.post(`${LAB_API}${path}`, body, cfg).then((r) => r.data),
    put: (path, body) => axios.put(`${LAB_API}${path}`, body, cfg).then((r) => r.data),
    del: (path) => axios.delete(`${LAB_API}${path}`, cfg).then((r) => r.data),
  };
};

export const errMsg = (e, fallback) => {
  const d = e?.response?.data?.detail;
  if (Array.isArray(d)) return d.map((x) => x.msg).join(', ');
  return d || fallback;
};
